
@if (linkOnly) {
  <span>
    @if (cvParam?.accession) {
      <span>
        <a href="{{ olsBaseUrl + cvParam?.accession }}"
        title="External: Access term '{{ cvParam?.accession }}' on EMBL-EBI's Ontology Lookup Service" target="_blank">
        <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
    </span>
    }
    @if (param?.cv_accession) {
    <span>
        <a href="{{ olsBaseUrl + param?.cv_accession }}"
        title="External: Access term '{{ param?.cv_accession }}' on EMBL-EBI's Ontology Lookup Service" target="_blank">
        <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
    </span>
    }
</span>
}
@if (!linkOnly) {
<span>
    @if (cvParam) {
    <span>
        {{ cvParam?.name | titlecase | nowrap }}{{ displayValue? (cvParam?.value ? ": " : "") : "" }}{{ displayValue? (cvParam?.value):""  | nowrap }}
    </span>
    }
    @if (param) {
    <span>
        {{ param?.name | titlecase | nowrap  }}{{ displayValue? (param?.value ? ": " : "") : "" }}{{ displayValue? (param?.value): "" | nowrap }}
    </span>
    }
</span>
}